import { render, staticRenderFns } from "./loginPhone.vue?vue&type=template&id=9cedf632&"
import script from "./loginPhone.vue?vue&type=script&lang=js&"
export * from "./loginPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports